import { ThemeOptions } from '@mui/material/styles'

const theme: ThemeOptions = {
    palette: {
        primary: {
            light: "#44C7E2",
            main: "#50A6D3",
            dark: "#27A2E3",
            contrastText: '#fff'
        },
        secondary: {
            light: "#0BC383",
            main: "#31AA49",
            dark: "#0A4E0D",
            contrastText: '#fff'
        }

    },
    components: {
        MuiButton: {
            defaultProps: { disableElevation: true }
        },
        MuiGrid: {
            defaultProps: {
                margin: 0
            }
        },
        MuiChip: {
            defaultProps: {
                style: {
                    marginRight: 3,
                    marginBottom: 3
                }
            }
        }
    }
}

export default theme;